import { c as _c } from "react/compiler-runtime";
import loadable from '@loadable/component';
import React from 'react';
import AboveTheFoldServerRenderer from 'components/essentials/AboveTheFoldServerRenderer';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useIsBrowser from 'hooks/useIsBrowser';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
// CON-7309: Temporarily removed to help isolate cause of performance issues
// import BrowserOnly from 'components/consumer/BrowserOnly';

const RecentlyViewed = loadable(() => import('components/consumer/recently-viewed'));

// CON-7309: Temporarily removed to help isolate cause of performance issues
// const RecommendedForYouCarousel = loadable(() =>
//   import('components/consumer/ProductCardCarousel/RecommendedForYouCarousel')
// );

const PDPFooterInner = () => {
  const $ = _c(8);
  const {
    data
  } = usePDPBasicDetails();
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] !== data?.sku || $[1] !== isBrowser) {
    t0 = !!isBrowser && <div data-crl8-container-id="product" data-crl8-filter={`productId:${data?.sku}`} data-crl8-lazy-load-experience="true" />;
    $[0] = data?.sku;
    $[1] = isBrowser;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = data?.id;
  let t2;
  if ($[3] !== t1) {
    t2 = <AboveTheFoldServerRenderer disableOnServer={true}><RecentlyViewed currentPDPProduct={t1} /></AboveTheFoldServerRenderer>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t2) {
    t3 = <>{t0}{t2}</>;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const PDPFooter = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SuspenseWithLoader><PDPFooterInner {...props} /></SuspenseWithLoader>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default PDPFooter;